class Util {

    public validCPF = (value: string) => {
        if (!value) return false;
        const cpf = value.replace(/[\D]/g, '');
        if (cpf.length !== 11 || /^([0-9])\1*$/.test(cpf)) {
            return false;
        }
        else {
            const digits = cpf.substring(9);
            const first = this.validCPFGetFirstDigit(cpf);
            const second = this.validCPFGetSecondDigit(cpf);
            const er = first + '' + second + '';
            return digits === er;
        }
    }

    private validCPFGetFirstDigit = (value: string) => {
        let mult = 10, sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += mult * parseInt(value.charAt(i) + '');
            mult--;
        }
        let rest = 11 - sum % 11;
        if (rest >= 10) rest = 0;
        return rest;
    }

    private validCPFGetSecondDigit = (value: string) => {
        let mult = 11, sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += mult * parseInt(value.charAt(i) + '');
            mult--;
        }
        let rest = 11 - sum % 11;
        if (rest >= 10) rest = 0;
        return rest;
    }

    public normalizeCnpj = (value: string | number | unknown[]): string => {
      if (value === undefined || value === null || value === '') return ''
      return String(value).trim().toUpperCase().replace(/[.\-/\s]/g, '')
    }

    public cnpjValidation = (value: string | number | unknown[]): boolean => {
      if (value === undefined || value === null || value === '') return false

      // Aceita string, número inteiro ou array de caracteres — preserva contrato anterior
      const validTypes =
        typeof value === 'string' || Number.isInteger(value as number) || Array.isArray(value)
      if (!validTypes) return false

      const cnpj = this.normalizeCnpj(value)

      // 12 alfanuméricos (uppercase) seguidos de 2 dígitos verificadores numéricos
      if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) return false

      // Defesa contra sequência repetida (ex: 00000000000000 / AAAAAAAAAAAA00)
      if (/^([A-Z0-9])\1{13}$/.test(cnpj)) return false

      const base = cnpj.substring(0, 12)
      const informed = cnpj.substring(12, 14)

      const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      const firstDigit = this.calculateCnpjDigit(base, firstWeights)
      const secondDigit = this.calculateCnpjDigit(base + firstDigit, secondWeights)

      return informed === `${firstDigit}${secondDigit}`
    }

    private calculateCnpjDigit = (value: string, weights: number[]): number => {
      let sum = 0
      for (let i = 0; i < value.length; i++) {
        // Conforme regra da Receita Federal: valor numérico do char = charCode - 48
        sum += (value.charCodeAt(i) - 48) * weights[i]
      }
      const remainder = sum % 11
      return remainder < 2 ? 0 : 11 - remainder
    }

}

export const ValidationUtil = new Util();
